/* eslint-disable */
import AxiosClient from './repositories/clients/axios'

const redirectInvalidUser = () => {
  window.location.replace(process.env.VUE_APP_URL + '#openAccount')
  return false
}

const getFileS3 = async link => {
  const url = process.env.VUE_APP_AWS_FILE + btoa(link)
  let responseS3 = null
  await AxiosClient()
    .get(url)
    .then(response => {
      if (response.data.url) {
        responseS3 = response.data.url
      }
    })
    .catch(function (error) {
      return error
    })

  return responseS3
}

const formatDocument = (document) => {
  if (document && document.length === 11) {
    const cpfMask = /(\d{3})(\d{3})(\d{3})(\d{2})/
    return document.replace(cpfMask, '$1.$2.$3-$4')
  }

  if (document && document.length === 14) {
    const cnpjMask = /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/
    return document.replace(cnpjMask, '$1.$2.$3/$4-$5')
  }

  return document
}

const currencyFormat = (value) => {
  if (typeof value === 'string') {
    return `R$ ${value}`
  }

  return Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value)
}

const dateFormat = (date) => {
  const dateObj = new Date(date)
  dateObj.setHours(dateObj.getHours() + 3)
  const day = String(dateObj.getDate()).padStart(2, '0')
  const month = String(dateObj.getMonth() + 1).padStart(2, '0')
  const year = String(dateObj.getFullYear())
  return `${day}/${month}/${year}`
}

export {
  redirectInvalidUser,
  getFileS3,
  formatDocument,
  currencyFormat,
  dateFormat
}
